import { companyInfo } from "@/mocks/help-center";

export default function Footer() {
  return (
    <footer className="bg-primary text-white relative z-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-12 md:py-16">
        <div className="text-center">
          <h3 className="text-xl md:text-2xl font-bold mb-6 tracking-tight font-heading">
            {companyInfo.name}
          </h3>
          <div className="space-y-1 text-white/80 mb-6 text-sm md:text-base">
            {companyInfo.address.map((line) => (
              <p key={line}>{line}</p>
            ))}
          </div>
          <div className="space-y-3">
            <div className="flex items-center justify-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line text-white" />
              </div>
              <span className="text-sm md:text-base">{companyInfo.email}</span>
            </div>
            <div className="flex items-center justify-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-white" />
              </div>
              <span className="text-sm md:text-base">{companyInfo.phone}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}